<template>
  <div class="mask-box" v-if="show" @click="closeConfirm">
    <div class="mask-content">
      <div class="confirm-header">
        <div v-for="item in confirmContent" :key="item">{{ item }}</div>
      </div>

      <div class="confirm-footer">
        <div class="confirm-cancel" @click.stop="confirmClick('cancel')">{{ cancelText }}</div>
        <div class="confirm-ok">
          <template>
            <span class="goWx" @click.stop="confirmClick('confirm')">{{ confirmText }}</span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    confirmContent: {
      type: Array,
      default: []
    },
    confirmText: {
      type: String,
      default: "立即前往"
    },
    cancelText: {
      type: String,
      default: "我知道了"
    }
  },
  watch: {
    visible(val) {
      this.show = val;
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    confirmClick(type) {
      this.$emit("confirmClick", type);
      
    },
    closeConfirm() {
      this.$emit("hideConfirm");
    }
  }
};
</script>
<style scoped lang="scss">
.mask-box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 45px;
  z-index: 9;
}
.mask-content {
  background: white;
  width: 330px;
  box-sizing: border-box;
  border-radius: 8px;
  text-align: center;
}
.confirm-header {
  font-size: 16px;
  padding: 30px 25px;
  color: #262626;
}
.confirm-footer {
  /*width: px580);*/
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #eeeeee;
}
.confirm-footer div {
  flex: 1;
  text-align: center;
  line-height: 50px;
  font-weight: initial;
  font-size: 16px;
  font-weight: bold;
}
.confirm-cancel {
  color: #999999;
  font-weight: initial !important;
}
.confirm-ok {
  color: #1890ff;
  line-height: 50px;
  border-left: 1px solid #eee;
}
.confirm-ok span {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/confirmDialog.vue